<h3>CALL FOR WORKSHOPS</h3>
<p> In the afternoon of the 15-th of December our Congress will host several workshops,
	each lasting approximately two hours. </p>

<h5> PROPOSALS </h5>
<p>
	Worksop proposals must be submitted to <a href="mailto:cifris23@decifris.it">cifris23&#64;decifris.it</a>.
	The deadline for proposals is the 15-th of September 2023.
</p>
<p> The proposal description must contain:</p>
<ul>
	<li> a name for the workshop</li>
	<li> a description for the workshop aim and subject</li>
	<li> at least two names of organizers</li>
	<li> a tentative workshop structure</li>
</ul>
<h5> TOPICS</h5>
<p>
	Any subject related to cryptography and its applications is welcome.
</p>
<p>Besides those listed in the <a href="https://www.decifris.it/cifris23/call-for-papers">call for papers</a>
	we accept also proposals related to the interaction of cryptography with society in a broad sense,
	such as legal aspects, socio-economic implications, privacy/digital rights of citizens, hacking community, etc.
</p>
<h5> ACCEPTANCE </h5>
<p>
	Accepted workshops will be notified within October.
</p>
<p>
	All workshop talks will be included, as 2-page mini-abstracts, in the Congress Proceedings and might thus
	be published in full form by the workshop organizers in other venues without any consent by De Cifris.
	All workshop participants must pay the Congress fee and will therefore have access to the full Congress.
</p>
<h5>LOCATION</h5>
<p>
	The conference will be held at <a target="_blank" href="https://www.consob.it/">CONSOB</a> headoffice, Via Giovanni
	Battista Martini, 3 - 00198 Rome (Italy).
</p>